import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useGetProjectNotesByIdQuery, useLazyGetProjectNotesByIdQuery, useUpsertProjectNotesMutation } from '../../../../../services/EndPointsApis';
import { useSelector } from 'react-redux';
import TextField from '../../../../../core/common/textFields/TextField';
import { toast } from 'react-toastify';
import RichTextEditor from '../../../../../core/common/Rich Text Editor/RichTextEditor';
import ReactQuill from 'react-quill';
import Select, { components } from 'react-select';
import { customStyles } from '../../../../../core/common/Custom Style/CustomStyle';
import * as Yup from "yup";


const NoteProjectSidebar = ({ notesId, activityTogglePopup, closeSidebar, setActivityTogglePopup, isEditing, refetch, projectLookups }: any) => {

    const params = useParams()

    const ProjectId = useSelector((state: any) => state.common.projectId);
    const projectId = params?.projectId

    //Upsert Project Notes Api
    const [UpsertProjectNotes, { data, isError, error, isSuccess, isLoading }] = useUpsertProjectNotesMutation()

    //Get Project Notes Details By Id APi
    const [triggerNotesData, { data: getNotesById }] = useLazyGetProjectNotesByIdQuery();

    const notesSchema = Yup.object().shape({
        lst_NoteType: Yup.object({
            id: Yup.number().min(1, 'Note Type must be selected').required('Note Type Id is required'),
            value: Yup.string().required('Note Type is required')
        }).required(),

        title: Yup.string().required("Title is required"),

    });

    //Formik
    const initialValues = {
        id: "00000000-0000-0000-0000-000000000000",
        projectId: projectId,
        title: "",
        description: "",
        privacyType: 1,
        createdAt: "2024-10-24T08:20:11.942Z",
        updatedAt: "2024-10-24T08:20:11.942Z",
        createdBy: 0,
        lst_NoteType: {
            id: 0,
            value: ""
        }
    }

    const formik = useFormik({
        validationSchema: notesSchema,
        initialValues,
        onSubmit: (values) => {
            UpsertProjectNotes({ ...values })
        }
    })
    const { resetForm } = formik;

    const handleSubmit = () => {
        formik.handleSubmit()
    }
    useEffect(() => {

        if (isSuccess) {
            toast.success(data?.message);
            setActivityTogglePopup(false)
            resetForm()
            refetch()
        }
    }, [isSuccess]);
    useEffect(() => {
        if (isError && error) {
            let errorMessage: string = 'Something went wrong';

            if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
                errorMessage = (error.data as { message: string }).message;
            }
            toast.error(errorMessage);
        }
    }, [isError, error]);
    useEffect(() => {
        if (!activityTogglePopup && !isEditing) {
            resetForm();
        }
    }, [activityTogglePopup]);


    useEffect(() => {
        if (notesId && isEditing) {
            triggerNotesData({ Id: notesId })
        }
    }, [notesId, activityTogglePopup])

    useEffect(() => {
        if (getNotesById?.result && Object.keys(getNotesById?.result).length > 0) {
            // setUpdateId(getNotesById?.result?.leadProspectId);
            formik.setValues({ ...getNotesById.result });
            // setDisabledata(true)
        } else {
            // setUpdateId(0);
        }
    }, [getNotesById]);

    return (
        <>

            <div className={activityTogglePopup ? "toggle-popup sidebar-popup" : "toggle-popup"}>
                <div className="sidebar-layout">
                    <div className="sidebar-header">
                        <h4>{isEditing ? "Edit Note" : "Add Note"} </h4>
                        <Link to="#" className="sidebar-close toggle-btn" onClick={closeSidebar}>
                            <i className="ti ti-x" />
                        </Link>
                    </div>
                    <div className="toggle-body">
                        <div className="toggle-height">
                            <div className="pro-create">
                                <form onSubmit={formik.handleSubmit}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <TextField
                                                label="Title"
                                                type="text"
                                                required
                                                {...formik.getFieldProps("title")}
                                            />
                                        </div>
                                        {formik.touched.title && formik.errors.title && (
                                            <div className="error">{formik.errors.title}</div>
                                        )}
                                         <div className='col-md-12'>
                                            <label className='input-label'>Note Type <span className="text-danger">*</span></label>

                                            <Select
                                                styles={customStyles}
                                                className="select"
                                                options={projectLookups?.result?.Lst_ProjectNoteType?.map((option: any) => ({
                                                    label: option?.value,
                                                    value: option?.id
                                                }))}
                                                value={
                                                    formik.values?.lst_NoteType?.id
                                                        ? {
                                                            value: formik.values?.lst_NoteType?.id,
                                                            label: formik.values?.lst_NoteType?.value || '',
                                                        }
                                                        : null
                                                }
                                                onChange={(selectedOption: any) => {
                                                    formik.setFieldValue('lst_NoteType.id', selectedOption.value);
                                                    formik.setFieldValue('lst_NoteType.value', selectedOption.label);

                                                }}
                                            />
                                        </div>
                                        {formik?.touched?.lst_NoteType && formik.errors.lst_NoteType && (
                                            <div className="error">{formik.errors.lst_NoteType.value}</div>
                                        )}
                                        <div className="col-md-12 d-flex align-items-center">
                                            <div className="radio-wrap">
                                                <label className="input-label">Notes Privacy <span className="text-danger">*</span></label>
                                                <div className="d-flex flex-wrap">
                                                    <div className="radio-btn">
                                                        <input
                                                            type="radio"
                                                            className="status-radio"
                                                            id="inactive1"
                                                            name="status"
                                                            checked={formik.values.privacyType === 1}
                                                            onChange={() => formik.setFieldValue('privacyType', 1)}
                                                        />
                                                        <label htmlFor="inactive1">Internal Notes</label>
                                                    </div>
                                                    <div className="radio-btn">
                                                        <input
                                                            type="radio"
                                                            className="status-radio"
                                                            id="active1"
                                                            name="status"
                                                            checked={formik.values.privacyType === 0}
                                                            onChange={() => formik.setFieldValue('privacyType', 0)}
                                                        />
                                                        <label htmlFor="active1">Client Notes</label>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div className="col-md-12 mt-2">
                                            {/* <div className="form-wrap">
                                                <label className="input-label">
                                                    Description <span className="text-danger">*</span>
                                                </label>
                                                <textarea
                                                    className="form-control"
                                                    rows={4}
                                                    value={formik.values?.description}
                                                    placeholder='Type....'
                                                    onChange={(e) => formik.setFieldValue('description', e.target.value)}
                                                />
                                            </div> */}
                                            <RichTextEditor
                                                value={formik.values.description}
                                                name="Description"
                                                onChange={(value: any) => formik.setFieldValue('description', value)}
                                            />

                                        </div>

                                       
                                    </div>
                                </form>
                            </div>
                            <div className="submit-button text-end">
                                <button type='button' className="btn btn-light sidebar-close" onClick={closeSidebar}>
                                    Cancel
                                </button>
                                <button
                                    type='button'
                                    className="btn btn-primary"
                                    onClick={handleSubmit}
                                >
                                    {isEditing ? "Update" : "Add"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    );
};

export default NoteProjectSidebar;
